import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";

export const servicesFaqBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.services-faq', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const accordeonItems = section.querySelectorAll(".services-faq__item");

    accordeonItems.forEach((currentTab) => {
        let headPart = currentTab.querySelector(".services-faq__item-head");
        let hiddenPart = currentTab.querySelector(".services-faq__item-hide");

        headPart.addEventListener('click', (e) => {
            // Закриваємо всі інші пункти
            accordeonItems.forEach((item) => {
                if (item !== currentTab) {
                    item.classList.remove("active");
                    let otherHiddenPart = item.querySelector(".services-faq__item-hide");
                    otherHiddenPart.style.maxHeight = null;
                }
            });

            // Перемикаємо поточний пункт
            let hiddenPartHeight = hiddenPart.scrollHeight;
            currentTab.classList.toggle("active");

            if (currentTab.classList.contains("active")) {
                hiddenPart.style.maxHeight = hiddenPartHeight + 'px';
            } else {
                hiddenPart.style.maxHeight = null;
            }
        });
    });
}